import React, { ReactNode } from 'react';
import { useAuth } from "../../global-components/src";

// Definindo os tipos de props
interface PermissionCheckProps {
    id_owner: number; // Ou o tipo que você usa para permissões
    permission: string; // Ou o tipo que você usa para permissões
    just_owner?: boolean; // Ou o tipo que você usa para permissões
    children: ReactNode; // ReactNode permite qualquer tipo de conteúdo, como texto, JSX, etc.
}

const PermissionCheck: React.FC<PermissionCheckProps> = ({ permission, children, id_owner, just_owner }) => {
    const { user, isSuper } = useAuth();

    // Verifica se o usuário tem permissões e renderiza as children se tiver
    if (
        isSuper() ||
        user?.id  === id_owner ||
        (user?.permissions?.includes(permission) && id_owner && id_owner > 5 && !just_owner)
    ) {
        return <>{children}</>;
    }

    return null; // Não renderiza nada se o usuário não tiver permissão
};

export default PermissionCheck;
